import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import dayGridPlugin from '@fullcalendar/daygrid';
import listPlugin from '@fullcalendar/list';
import FullCalendar from '@fullcalendar/react';
import timeGridPlugin from '@fullcalendar/timegrid';
import { CalendarStyleOverrides, CalendarStyleVariables } from './styles';
export const CalendarStyles = React.memo(function CalendarStyles() {
    return (_jsxs(_Fragment, { children: [_jsx(CalendarStyleOverrides, { styled: { variant: 'create' } }), _jsx(CalendarStyleVariables, {})] }));
});
export const Calendar = React.memo(function Calendar(props) {
    return _jsx(FullCalendar, { plugins: [dayGridPlugin, listPlugin, timeGridPlugin], initialView: 'dayGridMonth', firstDay: 1, ...props });
});
